// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vJduS","item":"styles_item__4j3P1","itemIcon":"styles_itemIcon__y0E1V","Text-root":"styles_Text-root__fvwoM"};